import React, { useLayoutEffect } from 'react'
import { createContext, useContext, useState } from "react"; //prettier-ignore
import { Loading } from "@/components/ui/Loading";
import { useThreeLoader } from "../hooks/useThreeLoader";
import { useReactQueryLoader } from "../hooks/useReactQueryLoader";
import { useMachine } from "@xstate/react";
import { loadMachine} from "../machine/loadMachine";
import { Machine } from "../machine/phases/index";

export const LoadingManagerCtx = createContext<{ phase: ReturnType<typeof useMachine>[0]; send: ReturnType<typeof useMachine>[1]; actorRef: ReturnType<typeof useMachine>[2]; } | null>(null);

export function LoadingManager({ children }: { children: React.ReactNode }) {

  // machine
  const [phase, send, actorRef] = useMachine(loadMachine)
  const [rebootKey, reboot] = useState(0)

  // loaders
  const loadersReady = useLoaders()
  if(!loadersReady) return
  
  return (
    <LoadingManagerCtx.Provider value={{ phase, send, actorRef }} >
    <Machine state={phase} send={send} reboot={reboot} actorRef={actorRef} />
      <React.Fragment key={rebootKey}>
        {children}
      </React.Fragment>
    </LoadingManagerCtx.Provider>
  );
}

export function useLoadingManager() {
  const ctx = useContext(LoadingManagerCtx);
  if (!ctx) {throw new Error("useLoadingManager must be used inside LoadingManager");} //prettier-ignore

  return {
    phase: ctx.phase,
    send: ctx.send,
    actorRef: ctx.actorRef,
  };
}

/** 
 * InitializeLoaders
 * Gates children rendering until Three.js and React Query callbacks are initialized.
 * useLayoutEffect ensures callbacks are set up before any preloading (which happens at import time)
 */
export function useLoaders() {
  useThreeLoader();
  useReactQueryLoader();
  const [ready, setReady] = useState(false);

  useLayoutEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setReady(true);
  }, []);

  return ready;
}

